const initialState = {
  flowType: "prescription-lenses" as FlowTypes,
  totalPrice: 0 as number,
  frame: null as Frame | null,
  frameColor: null as Color | null,
  lense: null as Lenses | null,
  medicalExamination: {
    rx: {
      left: {
        sph: "0.00",
        cyl: "0.00",
        axis: "0",
        add: "0.00",
      },
      right: {
        sph: "0.00",
        cyl: "0.00",
        axis: "0",
        add: "0.00",
      },
    },
    pd: "",
    prescriptionFiles: [] as File[],
    provideLater: false,
  },
  rx_id: null as number | null,
  lenseMaterial: null as LensMaterial | null,
  is_near_distance: false as boolean,
  is_far_distance: false as boolean,
  selectedLenseColorType: null as LensColorType | null,
  lensColor: null as LensColor | null,
  tintColor: 100 as TintColor,
  upgrades: [] as Upgrade[],
  reading_optometry_number: null,
  advancedOptions: null as AdvancedOption | null,
  transition_color_id: null as number | null,
  coupon: null as string | null,
};

const updatePrice = (state: any) => {
  let price = 0;
  if (state.frame) price += +state.frame.price;
  if (state.lense) price += +state.lense.price;
  if (state.lenseMaterial) price += +state.lenseMaterial.price;
  if (state.selectedLenseColorType)
    price += +state.selectedLenseColorType.price;
  if (state.advancedOptions) price += +state.advancedOptions.price;
  if (state.upgrades.length > 0) {
    state.upgrades.forEach((upgrade: any) => {
      price += +upgrade.price;
    });
  }
  return price;
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_FLOW_TYPE":
      return {
        ...state,
        flowType: action.data,
      };
    case "SET_SELECTED_FRAME":
      return {
        ...state,
        frame: action.data,
      };
    case "SET_SELECTED_LENSE":
      return {
        ...state,
        lense: action.data,
      };
    case "SET_TOTAL_PRICE":
      return {
        ...state,
        totalPrice: updatePrice(state),
      };
    case "SET_MEDICAL_EXAMINATION":
      return {
        ...state,
        medicalExamination: action.data,
      };
    case "SET_SELECTED_LENSE_MATERIAL":
      return {
        ...state,
        lenseMaterial: action.data,
      };
    case "SET_IS_NEAR_DISTANCE":
      return {
        ...state,
        is_near_distance: action.data,
      };
    case "SET_IS_FAR_DISTANCE":
      return {
        ...state,
        is_far_distance: action.data,
      };
    case "SET_LENS_COLOR_TYPE":
      return {
        ...state,
        selectedLenseColorType: action.data,
      };
    case "SET_LENS_COLOR":
      return {
        ...state,
        lensColor: action.data,
      };
    case "SET_TINT_COLOR":
      return {
        ...state,
        tintColor: action.data,
      };
    case "SET_UPGRADES":
      return {
        ...state,
        upgrades: action.data,
      };
    case "SET_FRAME_COLOR":
      return {
        ...state,
        frameColor: action.data,
      };
    case "SET_READING_OPTOMETRY_NUMBER":
      return {
        ...state,
        reading_optometry_number: action.data,
      };
    case "SET_SELECTED_ADVANCED_OPTIONS":
      return {
        ...state,
        advancedOptions: action.data,
      };
    case "SET_TRANSITION_COLOR_ID":
      return {
        ...state,
        transition_color_id: action.data,
      };
    case "SET_SAVED_RX":
      return {
        ...state,
        rx_id: action.data,
      };
    case "SET_COUPON":
      return {
        ...state,
        coupon: action.data,
      };
    case "RESET_ORDER_FLOW":
      return {
        ...initialState,
        
      };
    case "RESET_ORDER_FLOW_WITHOUT_FRAME":
      return {
        ...initialState,
        frame: state.frame,
        frameColor: state.frameColor,
      };
    case "RESTORE_ORDER_FLOW_FROM_CART":
      return {
        ...state,
        flowType: action.data.flowType || "prescription-lenses",
        frame: action.data.frame || null,
        frameColor: action.data.frameColor || null,
        lense: action.data.lense || null,
        medicalExamination: action.data.medicalExamination || initialState.medicalExamination,
        rx_id: action.data.rx_id ?? null,
        lenseMaterial: action.data.lenseMaterial || null,
        is_near_distance: action.data.is_near_distance || false,
        is_far_distance: action.data.is_far_distance || false,
        selectedLenseColorType: action.data.selectedLenseColorType || null,
        lensColor: action.data.lensColor || null,
        upgrades: action.data.upgrades || [],
        reading_optometry_number: action.data.reading_optometry_number ?? null,
        advancedOptions: action.data.advancedOptions || null,
        transition_color_id: action.data.transition_color_id ?? null,
        tintColor: action.data.tintColor ?? 100,
        totalPrice: updatePrice({
          ...state,
          ...action.data,
        }),
      };
    default:
      return state;
  }
};
